import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { IS_SPINNER_ACTIVE } from 'src/app/util/interceptors';
import { UrlService } from 'src/environments/urlService';
import { ChunkUploadDto } from '../../models/DTOs/gl-upload/ChunkUploadDto';


@Injectable({
  providedIn: 'root',
})
export class ChunkUploadBackendService {
  private readonly url;

  constructor(private httpClient: HttpClient,
    private urlService: UrlService,
  ) {
    this.url = this.urlService.getFmsUrl();
  }

  sendChunk(chunk: ChunkUploadDto): Observable<void> {
    return this.httpClient.post<void>(this.url + 'chunk-upload/save-chunk', chunk,
      { context: new HttpContext().set(IS_SPINNER_ACTIVE, false),
        withCredentials: true, responseType: 'json' });
  }
}
